import React from 'react';
import styles from './sections.module.css';
import CTAGroup, { InlineSignIn } from '../CTAGroup';

const FinalCTASection = ({
  title = 'Get started with Velox',
  body = 'Create your profile today. Add a contactless card when you want one, or talk to us about Velox for your team.',
  source = 'final_cta',
  intent,
  showSecondary = true,
  secondary = 'teams',
  primaryLabel = 'Get started',
}) => (
  <section className={`vxm-section ${styles.finalCta}`}>
    <span className={`vxm-glow ${styles.finalCtaGlow}`} />
    <div className={`vxm-container vxm-container--narrow ${styles.finalCtaInner}`}>
      <h2 className="vxm-h2 vxm-reveal">{title}</h2>
      <p className="vxm-lead vxm-lead--centred vxm-reveal">{body}</p>
      <div className="vxm-reveal">
        <CTAGroup
          source={source}
          intent={intent}
          align="center"
          showSecondary={showSecondary}
          secondary={secondary}
          primaryLabel={primaryLabel}
        />
        <InlineSignIn />
      </div>
    </div>
  </section>
);

export default FinalCTASection;
